var _path, _polygon, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYogabotIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1FD5B9",
    d: "M512,442.324C512,481.012,480.535,512,441.885,512H69.982C31.332,512,0,481.012,0,442.324V70.051 C0,31.363,31.332,0,69.982,0h371.903C480.535,0,512,31.363,512,70.051V442.324z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 243.729,
    y1: 131.951,
    x2: 297.6722,
    y2: 191.9989
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2026,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.2,
    fill: "url(#SVGID_1_)",
    points: "327.616,179.077 284.729,232.235 231.863,166.126 282.897,120.907 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 296.9063,
    y1: 249.8359,
    x2: 505.2492,
    y2: 481.2242
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2026,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fill: "url(#SVGID_2_)",
    d: "M405.092,152.425l-1.071,0.976c-0.427,0.843-1.022,1.708-1.716,2.586L280,302.934 v83.089c0,6.885-3.915,10.977-10.809,10.977h-26.121c-1.112,0-2.129-0.203-3.071-0.386v0.289l97,115.026l117.954,0.025 c32.92-5.662,58.046-34.062,58.046-68.63V294.102L405.092,152.425z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M402.345,155.987L280.08,302.934v83.089c0,6.885-3.995,10.88-10.889,10.88h-26.121 c-7.255,0-10.885-3.995-10.885-10.88v-82.372L109.911,155.987c-5.804-6.897-2.902-13.059,6.168-13.059h34.104 c5.443,0,9.801,1.809,13.065,6.885l93.974,116.475l93.968-116.475c3.263-5.076,7.616-6.885,13.059-6.885h31.569 C404.892,142.929,407.793,149.091,402.345,155.987"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M228.345,153.085v-16.997c0-13.531,7.633-20.991,20.994-20.991h17.688c13.355,0,20.989,7.46,20.989,20.991 v16.997c0,13.184-7.634,20.992-20.989,20.992h-17.688C235.978,174.077,228.345,166.269,228.345,153.085"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYogabotIcon);
export default __webpack_public_path__ + "static/media/yogabot_icon.11d135010418dfcf2d68530feb31483c.svg";
export { ForwardRef as ReactComponent };